import styleInject from '../../util/injectCss.js';

var css_248z = ".ToastContainer___fixed__9e0jU_v2-52-0 {\n  position: fixed;\n}\n.ToastContainer___absolute__EOPcc_v2-52-0 {\n  position: absolute;\n}\n.ToastContainer___relative__zaGnw_v2-52-0 {\n  position: relative;\n}";
var styles = {"ToastContainer___fixed":"ToastContainer___fixed__9e0jU_v2-52-0","ToastContainer___absolute":"ToastContainer___absolute__EOPcc_v2-52-0","ToastContainer___relative":"ToastContainer___relative__zaGnw_v2-52-0"};
styleInject(css_248z);

export { styles as default };
